export default __webpack_public_path__ + "media/trail/icons-controls-compass-e78d74f0.svg";